<!--  -->
<template>
	<div class="container">
		<div class="flex flex-container">
			<!-- 价格方案 -->
			<div class="flex-left">
				<div class="search-container flex flex-between">
					<div class="title">数据字典</div>
					<div v-if="isEdit">
						<img class="icon-img imagestyle" src="@/assets/images/reset.png" @click="handleReset" title="重置" alt="" />
						<img class="icon-img ml7" src="@/assets/images/disable.png" @click="updateStatusRow(0)" title="锁定" alt="" />
						<img class="icon-img ml7" src="@/assets/images/enable.png" @click="updateStatusRow(1)" title="解锁" alt="" />
						<img class="icon-img ml7" src="@/assets/images/delete.png" @click="handleDelete" title="删除" alt="" />
						<img class="icon-img ml7" src="@/assets/images/add.png" @click="handleEdit" title="新增" alt="" />
					</div>
				</div>
				<div class="mt10">
					<el-table
						v-el-table-infinite-scroll="tableLoad"
						:height="height"
						:infinite-scroll-distance="50"
						:infinite-scroll-immediate="false"
						:data="dicData"
						:row-class-name="rowClassName"
						:cell-style="cellStyle"
						:header-cell-style="{ background: 'rgba(200, 204, 215,.6)', color: '#333333' }"
						@cell-click="handleCellClick"
						border
						style="width: 100%">
						<el-table-column width="60" label="选择" align="center">
							<template slot-scope="scope">
								<el-radio v-model="selecteId" :label="scope.row.codesetId"></el-radio>
							</template>
						</el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="codesetName" label="名称" sortable></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="codesetCode" label="编码" sortable></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="editFlag" label="状态" sortable>
							<template slot-scope="scope">
								{{ scope.row.editFlag == "Y" ? "解锁" : "锁定" }}
							</template>
						</el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="remark" label="备注"></el-table-column>
					</el-table>
				</div>
			</div>
			<!-- 价格明细 -->
			<div class="flex-right ml20">
				<div class="search-container flex flex-between">
					<div class="title">
						字典项目
						<span v-if="levelData.length > 0" class="des-text ml10">
							(
							<span v-for="(item, i) in levelData" :key="i">
								<span class="cursor" @click="handleLevel(item, i)">{{ i == 0 ? item.codesetName : item.itemName }}</span>
								<i v-if="i < levelData.length - 1" class="el-icon-d-arrow-right"></i>
							</span>
							)
						</span>
					</div>
					<div v-if="isEdit">
						<img class="icon-img ml7" src="@/assets/images/delete.png" @click="handleDeleteChild" title="删除" alt="" />
						<img class="icon-img ml7" src="@/assets/images/add.png" @click="handleDescEdit" title="新增" alt="" />
					</div>
				</div>
				<div class="mt10">
					<el-table
						ref="multipleTable"
						v-el-table-infinite-scroll="tableLoadChild"
						:height="height"
						:infinite-scroll-distance="50"
						:infinite-scroll-immediate="false"
						:data="dicDetailData"
						:row-class-name="rowClassName"
						:cell-style="cellStyle"
						:header-cell-style="{ background: 'rgba(200, 204, 215,.6)', color: '#333333' }"
						@cell-click="handleChildCellClick"
						@selection-change="handleSelectionChange"
						border
						style="width: 100%">
						<el-table-column type="selection" width="50" align="center"></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="itemName" label="名称" sortable></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="itemCode" label="编码" sortable></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="levelSort" label="顺序" sortable></el-table-column>
						<el-table-column :show-overflow-tooltip="true" prop="remark" label="备注"></el-table-column>
						<el-table-column prop="" label="" width="50">
							<template slot-scope="scope">
								<i class="el-icon-d-arrow-left" @click="handleNext(scope.row)"></i>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<!--  -->
		</div>
		<dataEdit ref="dataEdit" @getSysCodeSetList="getSysCodeSetList"></dataEdit>
		<dataDesc ref="dataDesc" @getSysCodeSetChildList="getSysCodeSetChildList"></dataDesc>
	</div>
</template>

<script>
import dataEdit from "./components/data-edit.vue";
import dataDesc from "./components/data-desc.vue";
import { hasPermission } from "@/utils/permission";
export default {
	name: "dataDictionary",
	components: {
		dataEdit,
		dataDesc,
	},
	data() {
		return {
			height: 500,
			// 当前数据字典id
			selecteId: "",
			// 当前数据字典数据
			currentData: null,
			// 当前数据明细数据
			currentChildData: null,
			// 数据明细层级
			levelData: [],
			// 数据字典列表
			dicData: [],
			// 数据明细列表
			dicDetailData: [],
			// 数据明细选中列表
			checkboxList: [],
			isEdit: false,
		};
	},
	created() {
		this.height = window.innerHeight - 170;
		this.getSysCodeSetList();
		if (this.$route.meta.perm) {
			this.isEdit = hasPermission(this.$route.meta.perm);
			// console.log(this.isEdit)
		}
	},
	methods: {
		rowClassName({ row, rowIndex }) {
			let index = rowIndex + 1;
			if (index % 2 == 1) {
				return "warning-row";
			}
		},
		cellStyle({ row, column, rowIndex, columnIndex }) {
			if (columnIndex == 1) {
				return "cursor: pointer;";
			}
		},
		tableLoad() {},
		// 获取价格方案管理列表
		getSysCodeSetList() {
			let that = this;
			that.$request.post("sysCodeSetList", true, {}).then((res) => {
				if (res) {
					that.dicData = res.data;
				}
			});
		},
		// 新增/编辑
		handleEdit() {
			this.$refs.dataEdit.init();
		},
		// 点击数据字典
		handleCellClick(row, column, cell, event) {
			if (column.label == "名称") {
				if (row.editFlag == "N") {
					this.$message.error("当前数据字典已锁定");
					return;
				}
				this.$refs.dataEdit.init(row);
			} else {
				this.selecteId = row.codesetId;
				this.name = row.codesetName;
				this.currentData = row;
				this.levelData = [row];
				this.currentChildData = row;
				this.getSysCodeSetChildList();
			}
		},
		// 锁定/启用
		updateStatusRow(type) {
			if (this.selecteId == "") {
				this.$message.error("请选择数据字典");
				return;
			}
			let msg = "确认要" + (type ? "解锁" : "锁定") + "此数据字典吗？";
			this.$confirm(msg, {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					let that = this;
					that.$request
						.post("sysCodeUnlock", true, {
							codesetId: that.selecteId,
							editFlag: type ? "Y" : "N",
						})
						.then((res) => {
							if (res) {
								that.selecteId = "";
								that.currentData = null;
								that.currentChildData = null;
								that.levelData = [];
								that.dicData = [];
								that.dicDetailData = [];
								that.checkboxList = [];
								that.getSysCodeSetList();
								that.$message.success("操作成功");
							}
						});
				})
				.catch(() => {});
		},
		// 删除数据字典
		handleDelete() {
			if (this.selecteId == "") {
				return;
			}
			if (this.currentData.editFlag == "N") {
				this.$message.error("当前数据字典已锁定");
				return;
			}
			this.$confirm("确认要删除此数据字典吗？", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					let that = this;
					that.$request
						.post("deleteSysCodeSet", true, {
							codeIds: [that.selecteId],
						})
						.then((res) => {
							if (res) {
								that.selecteId = "";
								that.currentData = null;
								that.currentChildData = null;
								that.levelData = [];
								that.dicData = [];
								that.dicDetailData = [];
								that.checkboxList = [];
								that.getSysCodeSetList();
								that.$message.success("删除成功");
							}
						});
				})
				.catch(() => {});
		},
		tableLoadChild() {},
		// 获取数据明细列表
		getSysCodeSetChildList() {
			let that = this;
			that.$request
				.post("sysCodeSetChildList", true, {
					codesetId: that.currentChildData.codesetId,
				})
				.then((res) => {
					if (res) {
						that.dicDetailData = res.data;
					}
				});
		},
		// 价格明细编辑
		handleDescEdit() {
			if (this.selecteId == "") {
				this.$message.error("请选择数据字典");
				return;
			}
			if (this.currentData.editFlag == "N") {
				this.$message.error("当前数据字典已锁定");
				return;
			}
			console.log(this.currentChildData);
			this.$refs.dataDesc.init(this.currentChildData);
		},
		// 点击cell
		handleChildCellClick(row, column, cell, event) {
			if (column.label == "名称") {
				if (this.currentData.editFlag == "N") {
					this.$message.error("当前数据字典已锁定");
					return;
				}
				this.$refs.dataDesc.init(this.currentData, row);
			} else if (column.label == "") {
				this.currentChildData = row;
				this.currentChildData.codesetCode = this.currentData.codesetCode;
				this.currentChildData.codesetName = this.currentData.codesetName;
			} else {
				this.$refs.multipleTable.toggleRowSelection(row);
			}
		},
		handleSelectionChange(val) {
			this.checkboxList = val;
		},
		// 删除价格方案
		handleDeleteChild() {
			if (this.checkboxList.length == 0) {
				return;
			}
			if (this.currentData.editFlag == "N") {
				this.$message.error("当前数据字典已锁定");
				return;
			}
			let codeIds = [];
			this.checkboxList.forEach((item) => {
				codeIds.push(item.codesetId);
			});
			this.$confirm("确认要删除数据明细吗？", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
			})
				.then(() => {
					let that = this;
					that.$request
						.post("deleteSysCodeSet", true, {
							codeIds: codeIds,
						})
						.then((res) => {
							if (res.code == "0") {
								that.getSysCodeSetChildList();
								that.$message.success("删除成功");
							}
						});
				})
				.catch(() => {});
		},
		// 下一级
		handleNext(dt) {
			this.currentChildData = dt;
			this.levelData.push(dt);
			this.getSysCodeSetChildList();
		},
		// 点击切换层级
		handleLevel(dt) {
			let newArr = [];
			for (let index = 0; index < this.levelData.length; index++) {
				const element = this.levelData[index];
				newArr.push(element);
				if (element.codesetId == dt.codesetId) {
					break;
				}
			}
			this.levelData = newArr;
			this.currentChildData = dt;
			this.getSysCodeSetChildList();
		},
		// 重置
		handleReset() {
			let that = this;
			that.$request.post("downloadRelod", true, {}).then((res) => {});
			that.$request.post("sysCodeSetReload", true, {}).then((res) => {
				that.$message.success(res.msg);
			});
		},
	},
	beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
.container {
	// width: 99%;
	box-sizing: border-box;
	margin: 12px 26px 15px 10px;

	.el-table {
		// 深度选择器，去除默认的padding
		/deep/ th {
			padding: 0px;
		}

		/deep/ td {
			padding: 5px;
		}

		/deep/ .warning-row {
			background: #f1f1f5;
		}
		/deep/ th .el-table__cell {
			padding: 0 !important;
		}
	}
}

.search-container {
	background: #f9fafd;
	padding: 5px;
}

.flex-container {
	width: 100%;
	align-items: flex-start;
	box-sizing: border-box;
}

.flex-left {
	width: 55%;
	background: #fff;
	box-sizing: border-box;
	padding: 10px;
}

.flex-right {
	width: 43%;
	background: #fff;
	box-sizing: border-box;
	padding: 10px;
}
.title {
	line-height: 32px;
}
.el-icon-d-arrow-left {
	transform: rotate(-90deg);
	font-size: 18px;
	cursor: pointer;
}
.el-table__body-wrapper {
	overflow-y: scroll !important;
}
.el-icon-d-arrow-right {
	margin: 0 5px;
}
.imagestyle {
	background-color: #d9ece9;
	box-sizing: border-box;
	padding: 5px;
	border-radius: 3px;
}
</style>
<style scoped>
.cursor {
	cursor: pointer;
}
>>> .el-radio {
	margin-left: 6px;
}
>>> .el-radio .el-radio__label {
	display: none;
}
</style>
